import { render, staticRenderFns } from "./subMaterialRecord.vue?vue&type=template&id=b8ab5fe6&"
import script from "./subMaterialRecord.vue?vue&type=script&lang=js&"
export * from "./subMaterialRecord.vue?vue&type=script&lang=js&"
import style0 from "./subMaterialRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports